import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2 } from 'lucide-react';
import { BetaHero } from '../components/beta/BetaHero';
import { BetaAgreement } from '../components/beta/BetaAgreement';
import { BetaForm } from '../components/beta/BetaForm';

const API = process.env.REACT_APP_BACKEND_URL;

const Done = ({ email }) => (
  <section className="mt-12 bg-white border border-emerald-200 rounded-2xl p-6 sm:p-8" data-testid="beta-success">
    <CheckCircle2 className="w-10 h-10 text-[#0A7A55]" />
    <h2 className="beta-display mt-4 text-2xl sm:text-3xl font-extrabold text-[#0E2340]">You're in. Welcome to the PractCom beta!</h2>
    <p className="mt-3 text-lg text-[#46586E] leading-relaxed">
      Your free 90-day account is ready. We've emailed your login details to <strong className="text-[#0E2340]">{email}</strong> (check spam if
      it isn't there in a few minutes). When you log in, a short checklist walks you through your first 10 minutes.
    </p>
    <a href="/?fresh=true" className="mt-6 inline-flex items-center h-12 px-7 rounded-xl bg-[#0A7A55] hover:bg-[#086646] text-white font-bold" data-testid="beta-login-btn">Log in to PractCom</a>
  </section>
);

export default function BetaPage() {
  const [info, setInfo] = useState(null);
  const [doneEmail, setDoneEmail] = useState('');
  useEffect(() => {
    document.title = 'PractCom Beta Program — 10 practices, free';
    axios.get(`${API}/api/beta/info`).then((r) => setInfo(r.data)).catch(() => {});
  }, []);
  const finish = (email) => { setDoneEmail(email); window.scrollTo({ top: 0, behavior: 'smooth' }); };

  return (
    <div className="min-h-screen bg-[#F6F8FA] beta-page" data-testid="beta-page">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:wght@700;800&family=Source+Sans+3:wght@400;600;700&family=IBM+Plex+Mono:wght@500&display=swap');
        .beta-page{font-family:"Source Sans 3","Segoe UI",Arial,sans-serif}.beta-page .beta-display{font-family:"Schibsted Grotesk",Arial,sans-serif;letter-spacing:-.02em}
        .beta-page .font-mono{font-family:"IBM Plex Mono",ui-monospace,monospace}`}</style>
      <header className="border-b border-[#D9E2EB] bg-white">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <a href="/landing" className="flex items-center gap-2" data-testid="beta-logo-link">
            <img src="/onspace/assets/logo-mark.png" alt="" className="h-8 w-8" />
            <span className="beta-display text-2xl font-extrabold text-[#1784DD]">PractCom</span>
          </a>
          <a href="/?fresh=true" className="text-[#0B5FA8] font-semibold hover:underline" data-testid="beta-header-login">Log in</a>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 pb-20">
        {doneEmail ? <Done email={doneEmail} /> : (
          <>
            <BetaHero info={info} />
            <BetaAgreement terms={info?.terms} />
            {info && info.spotsLeft === 0 ? (
              <section className="mt-12 bg-white border border-[#D9E2EB] rounded-2xl p-6 sm:p-8" data-testid="beta-full">
                <h2 className="beta-display text-2xl font-extrabold text-[#0E2340]">All {info.spots} beta spots are taken</h2>
                <p className="mt-3 text-lg text-[#46586E]">Thank you for your interest. You can still try everything free for 15 days, no card needed.</p>
                <a href="/landing#start" className="mt-5 inline-flex items-center h-12 px-7 rounded-xl bg-[#0A7A55] hover:bg-[#086646] text-white font-bold" data-testid="beta-full-trial-btn">Start my free 15-day trial</a>
              </section>
            ) : <BetaForm onDone={finish} />}
          </>
        )}
      </main>
    </div>
  );
}
